export default "__VITE_ASSET__00SMQddO__"